import { render } from "./setting-switch.vue?vue&type=template&id=44c0739c"
import script from "./setting-switch.vue?vue&type=script&lang=js"
export * from "./setting-switch.vue?vue&type=script&lang=js"

import "./setting-switch.vue?vue&type=style&index=0&id=44c0739c&lang=less"

import exportComponent from "/Users/liuyansong/Work/Vue/test/vue3-video-player/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__